import React from "react";

import { FaqBlocks } from "components/faq-blocks";
import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { faqData } from "./data";

const title = "Frequently Asked Questions";

const FaqSection = () => {
  return (
    <HeroSection title={title}>
      <HeroSection.Content>
        <Heading tag="h2" className="text-center text-navy-dark mb-12">
          {title}
        </Heading>

        <FaqBlocks items={faqData} />
      </HeroSection.Content>
    </HeroSection>
  );
};

export default FaqSection;
